<script setup>
defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  id: {
    type: [String, Number],
    required: true,
  },
  label: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <div class="tw-inline-flex tw-items-center">
    <label
      class="tw-relative tw-flex tw-items-center tw-rounded-full tw-cursor-pointer"
      :for="id"
    >
      <input
        :id="id"
        type="checkbox"
        :value="modelValue"
        class="before:tw-content[''] tw-peer tw-relative tw-h-5 tw-w-5 tw-cursor-pointer tw-appearance-none tw-rounded-md tw-border tw-border-blue tw-transition-all before:tw-absolute before:tw-top-2/4 before:tw-left-2/4 before:tw-block before:tw-h-12 before:tw-w-12 before:tw--translate-y-2/4 before:tw--translate-x-2/4 before:tw-rounded-full before:tw-bg-blue before:tw-opacity-0 before:tw-transition-opacity checked:tw-border-blue checked:tw-bg-blue checked:before:tw-bg-blue hover:before:tw-bg-blue-dark"
        @input="emit('update:modelValue', !modelValue)"
      >

      <span class="tw-absolute tw-text-white tw-transition-opacity tw-opacity-0 tw-pointer-events-none tw-top-2/4 tw-left-2/4 tw--translate-y-2/4 tw--translate-x-2/4 tw-peer-checked:opacity-100">
        <SvgVue
          v-if="modelValue"
          class="tw-tw-absolute tw-tw-left-[6.5px] tw-tw-top-[6.5px] tw-tw-h-3.5 tw-tw-w-3.5 tw-tw-border-grey"
          icon="icons/check"
        />
      </span>

      <span
        v-if="label"
        class="tw-ml-2"
      >
        {{ label }}
      </span>
    </label>
  </div>
</template>
